import Route from "@/scripts/routeRegistrar"
const RouteRegistrar = new Route('');

RouteRegistrar.add("ticketing/ticketings/Ticketing", "tickets", "tickets", "مدیریت تیکتینگ")

const routes = RouteRegistrar.allRoutes()


export default routes;
